const applyShowPass = function (form) {
    form.find('.password-input-show, .show-password-toggle').on('click', function () {
        window.showPass($(this));
    });
}

export {
    applyShowPass
}
